import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

import { buildKey } from './buildKey';
import type { DismissState } from './DismissState';

export const setLocalState = async (aaid: string, state: DismissState): Promise<void> => {
	const key = buildKey(aaid);

	// Callers that need write visibility for a subsequent mutation or read can
	// await this Promise. Callers that do not care can still fire-and-forget via
	// `void setLocalState(...)`. Swallow async write failures so this helper
	// remains non-throwing for dismiss-state persistence.
	await AtlBrowserStorageLocal.setItem(key, JSON.stringify(state)).catch(() => {});
};
